export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.45.0-30c130124.svg#star","viewBox":"0 0 18.5 17.69"}